<div class="spinner-wrapper">
  <div class="spinner"></div>
  @if (message) {
    <p>{{ message }}</p>
  }
</div>
